// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { getModuleState } from '@accidents/store/reducers';
import * as EditAccident from '@accidents/store/reducers/edit-accident.reducer';

export const selectEditAccidentState = createSelector(
  getModuleState,
  state => state.editAccident
);

export const selectDetailAccidentLoading = createSelector(
  selectEditAccidentState,
  (state: EditAccident.AccidentEditState) => state.loadingEditAccident
);

export const retrySubmitSAPClaimantsLoading = createSelector(
  selectEditAccidentState,
  (state: EditAccident.AccidentEditState) =>
    state.loadingRetrySubmitSAPClaimants
);
